import { useState } from 'react';

import { ViewMyTicketsModal } from './ViewMyTicketsModal';

type Props = {
  roundId: bigint;
};

export const ViewMyTicketsButton = ({ roundId }: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const closeModalHandler = () => {
    setIsModalOpen(false);
  };

  const openModalHandler = () => {
    setIsModalOpen(true);
  };

  return (
    <>
      <ViewMyTicketsModal
        open={isModalOpen}
        onOpenChange={setIsModalOpen}
        closeModal={closeModalHandler}
        roundId={roundId}
      />
      <button
        className="msq-btn msq-btn-lg msq-btn-secondary w-full whitespace-nowrap"
        onClick={openModalHandler}
      >
        My Tickets
      </button>
    </>
  );
};
